module.exports = __webpack_public_path__ + "img/empty-pc.912c568.webp";